





























































































































import Vue from "vue";
import MonthTable from "@/components/MonthTable.vue";
import HabitAcomplishment from "@/components/HabitAcomplishment.vue";
import { mapState } from "vuex";
import Habit from "@/types/Habit";
import monthName from "@/utils/monthName";
export default Vue.extend({
  components: {
    MonthTable,
    HabitAcomplishment,
  },
  data() {
    return {
      loading: true,
      habit: null,
      showDeleteHabitDialog: false,
      selectedMonth: new Date().getMonth(),
      selectedYear: new Date().getFullYear(),
    };
  },
  computed: {
    ...mapState({
      habits: "habits",
    }),
    selectedMonthName() {
      return monthName(this.$data.selectedMonth as number)
        .toUpperCase()
        .substring(0, 3);
    },
  },
  mounted() {
    const habitId = this.$route.params.habitId;
    const habit = this.habits.find((habit: Habit) => habit.id === habitId);
    if (habit) {
      this.$data.habit = habit;
    }
    this.$data.loading = false;
  },
  methods: {
    handleBackClick(): void {
      this.$router.push("/");
    },
    handleDeleteClick() {
      this.$store.commit("deleteHabit", this.$data.habit.id);
      this.$router.push("/");
    },
    prevMonth() {
      this.$data.selectedMonth -= 1;
      if (this.$data.selectedMonth < 0) {
        this.$data.selectedMonth = 11;
        this.$data.selectedYear -= 1;
      }
    },
    nextMonth() {
      this.$data.selectedMonth += 1;
      if (this.$data.selectedMonth > 11) {
        this.$data.selectedMonth = 0;
        this.$data.selectedYear += 1;
      }
    },
  },
});
